import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

type Props = {
  item: Parameters<typeof FormattedMessage>[0];
  a11yItem: Parameters<typeof FormattedMessage>[0];
};

export const AriaExtendedText: React.FC<Props> = ({ item, a11yItem }) => {
  return item ? (
    <>
      <VisibleText>
        <FormattedMessage {...item} />
      </VisibleText>
      <AriaText>
        <FormattedMessage {...(a11yItem ?? item)} />
      </AriaText>
    </>
  ) : null;
};

const AriaText = styled.span`
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
  align-self: flex-start;
`;

const VisibleText = styled.span.attrs({ 'aria-hidden': true })`
  margin-right: -100%;
`;
